module.exports = __webpack_public_path__ + "static/img/green-sphere-312.cd74b34.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/green-sphere-312.png
// module id = yOza
// module chunks = 1